/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartLineV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m14.986 13.76 7.595 5.426-1.162 1.628-6.406-4.576-7.95 5.965-5.577-3.346 1.028-1.714 4.423 2.653zm0-6 7.595 5.426-1.162 1.628-6.406-4.576-7.95 5.965-5.577-3.346 1.028-1.714 4.423 2.653zm0-6 7.595 5.426-1.162 1.628-6.406-4.576-7.95 5.965-5.577-3.346 1.028-1.714 4.423 2.653z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartLineV as ChartLineV };
